import { ADJUST_NOTE_REQUIRED_MESSAGE } from './adjust-note-required-message.js';
import { isAdjustNoteRequired } from './is-adjust-note-required.js';
import { isAdjustReasonAllowed } from './is-adjust-reason-allowed.js';
/** Adds field issues when a reason doesn't fit the action, or "Other" arrives without a note. */
export function refineAdjustReason(value, context, actions) {
    if (value.reasonId == null) {
        return;
    }
    if (!actions.some((action) => isAdjustReasonAllowed(action, value.reasonId))) {
        context.addIssue({
            code: 'custom',
            message: 'That reason does not fit this change.',
            path: ['reasonId'],
        });
        return;
    }
    if (isAdjustNoteRequired(value.reasonId) && !value.note) {
        context.addIssue({
            code: 'custom',
            message: ADJUST_NOTE_REQUIRED_MESSAGE,
            path: ['note'],
        });
    }
}
//# sourceMappingURL=refine-adjust-reason.js.map